export const parseNumber = (value: any): number | null => {
    if (typeof value === "number") {
        return value;
    }

    if (typeof value === "string") {
        const parsed = parseFloat(value);
        if (!isNaN(parsed)) {
            return parsed;
        }
    }

    return null;
}

export const getThemeSpacingNumber = (spacing: string): number | null => {
    const spacingString = spacing.replace("px", "");
    return parseNumber(spacingString);
}

/**
 * Groups the integer part of a numeric value into blocks of three digits,
 * joined by the given separator (a space by default). Any non-digit characters
 * in the input are stripped, so it can be fed raw user input.
 *
 * Examples:
 *   formatNumberGroups("1234567")       -> "1 234 567"
 *   formatNumberGroups("1234567", ",")  -> "1,234,567"
 *   formatNumberGroups("12 34ab")       -> "1 234"
 */
export const formatNumberGroups = (
    value: string | number | null | undefined,
    groupSeparator: string = " "
): string => {
    if (value === null || value === undefined) return "";
    const digits = String(value).replace(/\D/g, "");
    if (!digits) return "";
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
}